import React, { FC, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import { fetchGarageListDetails } from "../../../api/apiService";
import { GarageDetailsAdditionalData, IGarageList } from "../../../interfaces/Interfaces";
import { NoData } from "../../table/NoData";
import { IdlocaGeneric } from "../../../locales/IdlocaGeneric";
import { RoutesPath } from "../../../enums/RoutesPath";
import { parseGarageDetails } from "../../../utils/parseGarageDetails";
import { GarageDetailsCard } from "./GarageDetailsCard";

export const MotoGarageDetails: FC = () => {
    const { id } = useParams<{ id: string }>();
    const [garage, setGarage] = useState<IGarageList | null>(null);
    const [details, setDetails] = useState<GarageDetailsAdditionalData | null>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const loadDetails = async () => {
            if (!id) return;
            setLoading(true);

            try {
                const data = await fetchGarageListDetails(+id);
                setGarage(data);
                setDetails(parseGarageDetails(data.details));
            } catch (e) {
                console.error("Failed to load garage:", e);
                setGarage(null);
            } finally {
                setLoading(false);
            }
        };
        loadDetails();
    }, [id]);

    if (loading) return <CircularProgress sx={{ display: "block", margin: "auto" }} />;

    if (!garage) {
        return (
            <NoData
                messageLocaId={IdlocaGeneric.no_garage_details}
                redirectButtonLocaId={IdlocaGeneric.go_to_garages}
                redirectUrl={RoutesPath.MOTO_GARAGES}
            />
        );
    }

    return <GarageDetailsCard garage={garage} details={details} />;
};
